import { forwardRef, type SVGProps } from "react";
// eslint-disable-next-line react/display-name
const SvgModuleSettings = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.67395 13.1484H19.8423" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M1.67395 5.14844H11.2008" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M16.016 5.14844L24.674 5.14844" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle
      cx="13.674"
      cy="5.25772"
      r="2.25"
      className="icon-color-4"
      fill="#fff"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle
      cx="22.2008"
      cy="13.2577"
      r="2.25"
      className="icon-color-4"
      fill="#fff"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M1.67395 21.1484H5.20081" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M10.674 21.1484L24.674 21.1484" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle
      cx="8.20081"
      cy="21.2577"
      r="2.25"
      className="icon-color-4"
      fill="#fff"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
));
export default SvgModuleSettings;
